/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
Command: npx gltfjsx@6.5.3 ..\second-floor.glb --transform 
Files: ..\second-floor.glb [39.05MB] > C:\Users\fabia\OneDrive\Dokumente\Dateien\To-Do\IDPA_BM-Campus\glb\gltfjsx\second-floor-transformed.glb [1.73MB] (96%)
*/

import React from 'react'
import { useGLTF } from '@react-three/drei'

export function SecondFloorModel(props) {
  const { nodes, materials } = useGLTF('/models/second-floor-transformed.glb')
  return (
    <group {...props} dispose={null}>
      <mesh geometry={nodes['second-floor'].geometry} material={materials['Benutzerdefiniert (4)']} position={[-10, 0, -18.5]} rotation={[Math.PI / 2, 0, 0]} scale={0.001} />
    </group>
  )
}

useGLTF.preload('/models/second-floor-transformed.glb')
